var React = require('react');

function IconOpenSource (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M645.385 617.403V348.462H381.644v268.809l-91.229 166.511c-90.848-68.234-149.613-176.875-149.613-299.241 0-206.559 167.449-374.008 374.008-374.008s374.008 167.449 374.008 374.008c0 111.433-48.733 211.483-126.049 280.002l-117.384-147.14zM491.702 857.847h46.217c-7.643.466-15.348.702-23.108.702-7.761 0-15.466-.236-23.109-.702z"}));
}

IconOpenSource.displayName = "IconOpenSource";

IconOpenSource.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconOpenSource;

IconOpenSource.default = IconOpenSource;
